export const EVENT_MIN_DURATION_IN_MINUTES = 5;

export const EVENT_DEFAULT_DURATION_IN_MINUTES = 60;

export enum EventWizardStep {
  EventDetails,
  NattersSetup,
  Tags,
  EntrySurvey,
  ExitSurvey,
}
